import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController, AlertController, ModalController } from '@ionic/angular';
import { DataAccessService } from '../../../../services/data-access.service';
import { SaleMethods } from '../../../../../constants/SaleMethods';
import { CustomSelectComponent } from '../../../../components/common/custom-select/custom-select.component';
import { TabsPage } from '../tabs.page';
import { PermissionService } from '../../../../services/permission-service.service';
import { AppPermissions } from '../../../../typed-permissions/app-permissions';
import { LocalStorageKeys } from '../../../../../constants/LocalStorageKeys';

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {

    tabPage: TabsPage;
    accessableBranchCount: number = 0;
    versionCode: string = '';

    constructor(private router: Router, private popOverController: PopoverController, private dataAccess: DataAccessService, private alertController: AlertController, private modalController: ModalController, private permissionService: PermissionService) { }

    ngOnInit() {
        this.accessableBranchCount = Number(localStorage.getItem(LocalStorageKeys.AccessableBrancheCount));
        this.versionCode = DataAccessService.versionCode;
    }

    async logOut() {

        const alert = await this.alertController.create({
            header: 'Warning',
            message: 'Are you sure you want to Log Out?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (x) => {

                    }
                },
                {
                    text: 'Yes',
                    cssClass: 'secondary',
                    handler: (x) => {
                        localStorage.removeItem(LocalStorageKeys.LoginToken);
                        localStorage.removeItem(LocalStorageKeys.Permissions);

                        this.popOverController.dismiss();
                        this.router.navigate(['/login']);
                    }
                }
            ]
        });

        await alert.present();
    }

    getSwitchSaleMethodText() {
        return this.dataAccess.ActiveSaleMethod === SaleMethods.Retail ? 'Switch to Wholesale' : 'Switch to Retail';
    }

    async switchSaleMethod() {

        const alert = await this.alertController.create({
            header: 'Warning',
            message: 'Are you sure you want to switch the Sale Method?',
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: (x) => {

                    }
                },
                {
                    text: 'Yes',
                    cssClass: 'secondary',
                    handler: (x) => {
                        var newMethod = this.dataAccess.ActiveSaleMethod === SaleMethods.Retail ? SaleMethods.WholeSale : SaleMethods.Retail;
                        localStorage.setItem(LocalStorageKeys.ActiveSaleMethod, newMethod + '');
                        this.dataAccess.ActiveSaleMethod = newMethod;

                        this.dataAccess.initHttpOptions();
                        this.popOverController.dismiss();

                        //this.dataAccess.getAllStats().subscribe(x => {

                        //});
                    }
                }
            ]
        });

        await alert.present();
    }

    async showBranchList() {
        this.popOverController.dismiss();

        await this.dataAccess.showServerLoadingAsync();

        this.dataAccess.getBranches(false).subscribe(async (x) => {
            this.dataAccess.dismissServerLoading();

            if (x['error']) {
                this.dataAccess.showErrorMessage('Error', x['error']);
            }
            else {

                var currentBranch = localStorage.getItem(LocalStorageKeys.ActiveBranchID);

                let data = await CustomSelectComponent.show({
                    dataArray: x['Branches'],
                    modalController: this.modalController,
                    selected: currentBranch,
                    title: 'Branch',
                    ts: null,
                    valueKey: 'ID',
                    allowCreatingNewItems: false,
                    cols: null,
                    hideClearButton: true,
                    multiSelect: false,
                    nameKey: 'Name',
                });

                    //.showCustomSelect(this.modalController, 'Branch', x['Branches'], 'ID', 'Name', false, true);


                if (data && data.Value != currentBranch) {
                    const confirmAlert = await this.alertController.create({
                        header: 'Warning',
                        message: `Are you sure you want to switch the Branch to '${data.Text}'?`,
                        buttons: [
                            {
                                text: 'No',
                                role: 'cancel',
                                cssClass: 'secondary',
                                handler: (x) => {

                                }
                            },
                            {
                                text: 'Yes',
                                cssClass: 'secondary',
                                handler: (x) => {
                                    this.dataAccess.updateImpersonatedBranchID(data.Value).subscribe((r) => {

                                        if (r['error']) {
                                            this.dataAccess.showErrorMessage('Error', r['error']);
                                        }
                                        else {
                                            localStorage.setItem(LocalStorageKeys.ActiveBranchID, r['ID']);
                                            localStorage.setItem(LocalStorageKeys.ActiveBranchName, r['Name']);
                                            localStorage.setItem(LocalStorageKeys.ActiveBranchCode, r['Code']);
                                            this.tabPage.setBranchName();
                                        }
                                    });
                                }
                            }
                        ]
                    });

                    await confirmAlert.present();
                }
            }
        });
    }

    async showLanguageList() {
        this.popOverController.dismiss();

        await this.dataAccess.showServerLoadingAsync();

        this.dataAccess.getLanguages().subscribe(async (x) => {
            this.dataAccess.dismissServerLoading();

            if (x['error']) {
                alert(x['error']);
            }
            else {

                var currentLang = this.dataAccess.LanguageKey;

                let data = await CustomSelectComponent.show({
                    dataArray: x['Languages'],
                    modalController: this.modalController,
                    selected: currentLang,
                    title: 'Language',
                    ts: null,
                    valueKey: 'ISOCode',
                    allowCreatingNewItems: false,
                    cols: null,
                    hideClearButton: true,
                    multiSelect: false,
                    nameKey: 'Name'
                });

                    //.showCustomSelect(this.modalController, 'Language', x['Languages'], 'ISOCode', 'Name', false, true);

                if (data && data.Value != currentLang) {
                    localStorage.setItem(LocalStorageKeys.LanguageCode, data.Value);
                    window.location.reload();
                }
            }
        });
    }

    canSwitchSaleMethods() {
        return this.dataAccess.ActiveSaleMethod === SaleMethods.Retail ?
            this.permissionService.PermissionManager.canRead(AppPermissions.AllPermissions.Parts.SaleMethods.Wholesale) :
            this.permissionService.PermissionManager.canRead(AppPermissions.AllPermissions.Parts.SaleMethods.Retail);
    }

    canSwitchBranches() {
        return this.accessableBranchCount > 1;
    }
}
